import { render } from "./NftOrderDetail.vue?vue&type=template&id=cc0fdcb8&scoped=true"
import script from "./NftOrderDetail.vue?vue&type=script&lang=js"
export * from "./NftOrderDetail.vue?vue&type=script&lang=js"

import "./NftOrderDetail.vue?vue&type=style&index=0&id=cc0fdcb8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc0fdcb8"]])

export default __exports__